export function getInitial(role) {
    var _a, _b, _c, _d, _e, _f;
    return "".concat((_f = (_b = (_a = role === null || role === void 0 ? void 0 : role.userGroupName) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : (_e = (_c = role.name) === null || _c === void 0 ? void 0 : (_d = _c[0]).toUpperCase) === null || _e === void 0 ? void 0 : _e.call(_d)) !== null && _f !== void 0 ? _f : '');
}
